import Api from  "@/services/AxiosAPI";

export default {
  
  getcms(route) {
    return Api.getData('help/' + route)
      .then(responses => {
        return responses
      });

  },
    cataloguerequest(user,catalog) {
        let formdata = {
            catalogs: catalog,
            email: user.email,
            courtesy_title: user.courtesy_title,
            first_name: user.first_name,
            last_name: user.last_name,
            company_name: user.company_name,
            address_1: user.address_1,
            address_2: user.address_2,
            town: user.town,
            county: user.county,
            postcode: user.postcode,
            country_id: user.country_id,
            phone: user.phone,
            fax: user.fax,
            lead_source: 'Catalogue Request'
        };
        console.log(formdata);
        return Api.postData('catalogue-request',formdata)
                .then(responses => {
                return responses
            });

    },
    getContactInfo() {
      return Api.getData('websiteContacts')
        .then(responses => {
          return responses
        });
    },
}